import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MainVisual from './components/MainVisual';
import ReasonSection from './components/ReasonSection';
import JobsSection from './components/JobsSection';
import SurveySection from './components/SurveySection';
import FaqSection from './components/FaqSection';
import { SurveyProvider } from '../../contexts/SurveyContext';

export default function Home() {
  return (
    <SurveyProvider>
      <div style={{ minHeight: '100vh', maxWidth: '480px', margin: '0 auto', overflowX: 'hidden' }}>
        <Header />
        <main>
          <MainVisual />
          <ReasonSection />
          <JobsSection />
          <SurveySection />
          <FaqSection />
        </main>
        <Footer />
      </div>
    </SurveyProvider>
  );
}
